var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactsWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.102,
    viewBox: "0 0 18 18.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contacts_default_16px",
    transform: "translate(-369 -288.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160570",
    "data-name": "Group 160570",
    transform: "translate(369 289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    d: "M15.749,16.475a4.911,4.911,0,0,1,.736,2.473,15.927,15.927,0,0,1-11.956,0c.056-2.913,2.713-5.258,5.978-5.258a8.478,8.478,0,0,1,2.529.464",
    transform: "translate(-2.082 -3.911)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    d: "M14.246,5.273A2.993,2.993,0,1,1,11.253,2.28h0a2.987,2.987,0,0,1,2.985,2.993Z",
    transform: "translate(-2.827 -1.632)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 0.456,
    cy: 0.456,
    r: 0.456,
    transform: "translate(11.891 10.843)",
    fill: "#8f959d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsWhiteIcon);
export default __webpack_public_path__ + "static/media/contacts-white-icon.243a51c7a1b93d3494112b8df6735bf0.svg";
export { ForwardRef as ReactComponent };